import { forwardRef, HTMLProps, useState } from 'react'
import clsx from 'clsx'

type CheckboxProps = HTMLProps<HTMLInputElement>

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, defaultChecked, value, ...rest }, ref) => {
    const [switchState, setSwitchState] = 
      useState<boolean | undefined>(defaultChecked);

    const onClick = () => {
      setSwitchState(!switchState)
    }
    
    return (
      <div className={`${className ? className : "mb-4 w-52"}`}>
        <label htmlFor={id} data-content={label} className="font-semibold text-sm">
          {label}
        </label>
          <div onClick={onClick} className="relative">
            <input
              id={id}
              className="absolute w-10 h-8 opacity-0 z-50 cursor-pointer"
              type="checkbox"
              defaultChecked={defaultChecked}
              ref={ref}
              value={value}
              {...rest}
              />
          </div>
          <div className={
            clsx('w-11 h-6 mt-2 bg-gray-300 rounded-full p-1 transition duration-300 ease-in-out', 
            { 'bg-green-500': switchState })}>
            <div className={
              clsx(`transform translate-x-0 w-4 h-4 bg-white rounded-full shadow-md transition duration-300 ease-in-out`, 
              { 'translate-x-5': switchState })}></div>
          </div>
      </div>
    );
  }
);

export default Checkbox;
